import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Loading from '../components/Loading';
import EmailVerificationNeeded from './EmailVerificationNeeded';
import HomePage from './HomePage';
import SetUpProfile from './setUpProfile';
import { Helmet } from 'react-helmet';

const Home = () => {
    const profileStatus = useSelector(state => state.profile.status);
    const error = useSelector(state => state.profile.error);
    const profile = useSelector(state => state.profile);
    const [displayEmailVerify, setDisplayEmailVerify] = useState(false);

    console.log('Profile Status is: ' + profileStatus);

    let content;

    //const { user } = useAuth0();
    //
    ////this is annoying me
    ////This enabled Email verification needed. However, im not getting the emails every time
    //useEffect(() => {
    //    if (
    //        user !== undefined &&
    //        user.email_verified !== undefined &&
    //        user.email_verified === false
    //    ) {
    //        setDisplayEmailVerify(true);
    //    }
    //}, [user]);

    if (profileStatus === 'loading') {
        content = <Loading />;
    } else if (profileStatus === 'succeeded') {
        // Sort posts in reverse chronological order by datetime string
        if (
            profile.profile.Data.Count === 0 ||
            (profile.profile.Data.Items[0].verified === undefined &&
                profile.profile.Data.Items[0].type === 'Teacher')
        ) {
            content = <SetUpProfile profile={profile.profile} />;
        } else if (displayEmailVerify) {
            content = <EmailVerificationNeeded />;
        } else {
            content = <HomePage />;
        }
    } else if (profileStatus === 'error') {
        content = <div>{error}</div>;
    }

    return (
        <>
            <Helmet>
                <title>AirTeachr App</title>
                <meta
                    name="description"
                    content="
                    airTeachr is the one stop platform for hiring, booking and managing Casual Relief Teacher in Australian schools."
                />
            </Helmet>
            <Box
            // sx={{
            //     backgroundImage: `url('${background}')`,
            //     backgroundColor: '#FFF',
            //     'background-size': 'cover',
            //     height: '100vh',
            // }}
            >
                {content}
            </Box>
        </>
    );
    //<section className="profile-list">{content}</section>;
};

//This page is the location users are routed too when they log in
//It will detect if the user has a profile or not
//with no profile the user will be navigated to setUpProfile
//With a completed profile the user will be navigated to the Dashboard
export default withAuthenticationRequired(Home, {
    onRedirecting: () => <Loading />,
});
